import { Button, Modal } from "antd-mobile";
import styles from "./styles.module.scss";
import classNames from "classnames";

export interface IAppUpdateModal {
  visible: boolean;
}

export const AppUpdateModal: FC<IAppUpdateModal> = ({ visible }) => {
  const onUpdate = () => {
    window.location.href =
      "https://apps.apple.com/us/app/circadia-cip/id1671300278";
  };
  return (
    <Modal
      visible={visible}
      className={styles.modalCon}
      closeOnMaskClick={false}
      showCloseButton={false}
      content={
        <div className={classNames(styles.content, "mt-2")}>
          <p id="sub-title" className={styles.subTitle}>
            Please update the app to latest version.
          </p>
          <Button
            id="update-btn"
            fill="solid"
            color="primary"
            onClick={onUpdate}
          >
            Update
          </Button>
        </div>
      }
    />
  );
};
